import { Typography } from '@mui/material';
import i18n from 'plmweb-common-helpers/dist/i18n';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { AuthenticationProvider } from '@lectra/react-authentication';
import config from '../config';
import { STORAGE } from '../constants';
import Loader from '../components/ui/Loader';
import { hasTokens } from '../selectors/user.selectors';
import safeSessionStorage from '../helpers/safeSessionStorage';
import { getAuth0Config } from '../selectors/authentication.selectors';
import { LoggingInLoaderContainer } from './WithAuthenticationProvider.style';
import { authenticateWithEmbeddedMode } from '../actions/authenticationActions';
const envMap = { develop: 'DEV', test: 'TEST', prod: 'PROD' };
const getLanguageForAuthenticationForm = () => {
    const selectedLanguage = safeSessionStorage.getItem(STORAGE.SESSION.SELECTED_LANGUAGE_KEY);
    return selectedLanguage === 'zh-cn' ? 'zh-cn' : selectedLanguage?.split('-')[0] || 'en';
};
const WithAuthenticationProvider = (props) => {
    const { auth0Config, hasUserTokens, actions } = props;
    useEffect(() => {
        actions.authenticateWithEmbeddedMode();
    }, [hasUserTokens, actions]);
    const languageForAuthenticationForm = getLanguageForAuthenticationForm();
    return (React.createElement(AuthenticationProvider, { "data-testid": 'authentication-provider', auth0: auth0Config, environment: envMap[config.mode], params: { language: languageForAuthenticationForm }, LoaderComponent: React.createElement(LoggingInLoader, null) }, props.children));
};
const LoggingInLoader = () => {
    return (React.createElement(LoggingInLoaderContainer, null,
        React.createElement(Loader, null),
        React.createElement(Typography, { variant: "subtitle1", "data-testid": "authenticating-logging-in-progress-in-browser" }, i18n._('auth.authentication.status.logging.in.pending'))));
};
const mapStateToProps = (state) => ({
    hasUserTokens: hasTokens(state),
    auth0Config: getAuth0Config(state),
});
const mapDispatchToProps = (dispatch) => ({
    actions: {
        authenticateWithEmbeddedMode: () => dispatch(authenticateWithEmbeddedMode()),
    },
});
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(WithAuthenticationProvider);
export const testables = { WithAuthenticationProvider };
